import type { IconSvgObject } from './types';

const Award03Icon: IconSvgObject = [
  ["path", { d: "M18 22V20C18 18.8954 17.1046 18 16 18H8C6.89543 18 6 18.8954 6 20V22", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 22H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 18L7.27198 7.19987C7.11563 6.22269 7.69743 5.27809 8.64045 4.97804L16.4056 2.50732C17.1264 2.27796 17.8311 2.90105 17.6917 3.64453L15 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Award03Icon;
